import { useEffect, useMemo, useState, type DependencyList } from "react";

export const DEFAULT_PAGE_SIZES = [10, 25, 50, 100] as const;
export const PAGINATION_THRESHOLD = 50;

export function useClientPagination<T>(items: T[], resetDeps: DependencyList) {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState<number>(50);

    useEffect(() => {
        setPage(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, resetDeps);

    const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
    const safePage = Math.min(page, totalPages - 1);

    const pagedItems = useMemo(
        () => items.slice(safePage * pageSize, (safePage + 1) * pageSize),
        [items, safePage, pageSize],
    );

    return {
        page: safePage,
        setPage,
        pageSize,
        setPageSize,
        totalPages,
        pagedItems,
        totalCount: items.length,
        showPagination: items.length > PAGINATION_THRESHOLD,
        PAGE_SIZES: DEFAULT_PAGE_SIZES,
    };
}
